/** Solid chip border + fill — replaces gradient pseudo-border chips */
export const CHIP_BORDER_CLASS = "border border-[#7D3BEE]";
export const CHIP_BG_CLASS = "bg-[#4F46E51A]";
export const CHIP_SOLID_SURFACE = `${CHIP_BORDER_CLASS} ${CHIP_BG_CLASS}`;

export const CHIP_RADIUS_LG = "rounded-[15.55px]";
export const CHIP_RADIUS_SM = "rounded-[11.95px]";
export const CHIP_RADIUS_CATEGORY = "rounded-[19.1px]";

export const DARK_CHIP_BG_CLASS = "bg-[#4F46E50F]";

/** App-page pill badges (tutorials, docs, API, etc.) */
export const APP_PAGE_CHIP_CLASS =
  "inline-flex items-center justify-center rounded-full border border-indigo-300 bg-indigo-50 px-4 py-2";
